var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBedDouble(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 43.75H5",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55 52.5V40C55 35.286 55 32.929 53.5355 31.4645C52.071 30 49.714 30 45 30H15C10.286 30 7.92892 30 6.46447 31.4645C5 32.929 5 35.286 5 40V52.5",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 30V25.5335C27.5 24.5818 27.357 24.2635 26.6243 23.8884C25.0988 23.1073 23.2466 22.5 21.25 22.5C19.2534 22.5 17.4014 23.1073 15.8756 23.8884C15.143 24.2635 15 24.5818 15 25.5335V30",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45 30V25.5335C45 24.5818 44.857 24.2635 44.1243 23.8884C42.5988 23.1073 40.7467 22.5 38.75 22.5C36.7533 22.5 34.9012 23.1073 33.3757 23.8884C32.643 24.2635 32.5 24.5818 32.5 25.5335V30",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 30V18.4014C52.5 16.6723 52.5 15.8078 52.0197 14.9913C51.5392 14.1749 50.855 13.7523 49.486 12.9071C43.9672 9.49945 37.2483 7.5 30 7.5C22.7517 7.5 16.0329 9.49945 10.514 12.9071C9.1451 13.7523 8.46068 14.1749 7.98033 14.9913C7.5 15.8078 7.5 16.6723 7.5 18.4014V30",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedDouble);
export default __webpack_public_path__ + "static/media/bed-double.0bc267150e9397414212037feffa7eb1.svg";
export { ForwardRef as ReactComponent };